export const iconFontAwesomeMoneyFlorinSign = (
	<i className="fa-solid fa-florin-sign"></i>
);
